declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

// Conversion tracking is handled by Google Tag Manager (container GTM-KRHZH8WZ, loaded in index.html).
// On successful organization setup we push this event to the dataLayer. The GTM container must have a
// Custom Event trigger on this exact name, wired to:
//   - a Conversion Linker tag (trigger: All Pages), and
//   - a Google Ads Conversion Tracking tag: Conversion ID 18207393507, Label HsFiCJu8w8McEOON--lD
//     (use the {{DLV - value}} / {{DLV - currency}} dataLayer variables for value/currency).
const REGISTRATION_EVENT =
  ((import.meta as any).env.VITE_GTM_REGISTRATION_EVENT as string | undefined) || "registration_complete";
const REGISTRATION_CURRENCY =
  ((import.meta as any).env.VITE_GTM_REGISTRATION_CURRENCY as string | undefined) || "PLN";
const REGISTRATION_VALUE = (() => {
  const raw = (import.meta as any).env.VITE_GTM_REGISTRATION_VALUE as string | undefined;
  const parsed = raw != null && raw !== "" ? Number(raw) : NaN;
  return Number.isFinite(parsed) ? parsed : 1.0;
})();

/**
 * Pushes the organization-creation conversion event to the GTM dataLayer.
 * GTM fires the actual Google Ads conversion (and any GA4 tags) off this event.
 * Safe to call from a React Router (client-side) navigation flow: the document is
 * not reloaded, so GTM tags fire normally after the push.
 */
export function trackAccountCreationConversion(organizationId?: string): void {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: REGISTRATION_EVENT,
    value: REGISTRATION_VALUE,
    currency: REGISTRATION_CURRENCY,
    transaction_id: organizationId,
  });
}
